import { defineMessages } from 'react-intl';

export const messages = defineMessages({
    seatsLabel: {
        id: 'front-app/BookingFlightPage/StepsSummary/Seats/Summary:seatsLabel',
        defaultMessage: '{total} seat(s)',
    },
});
